import LoadingWrapper from "../../../shared/components/LoadingWrapper";
import { inputColumns, inputTableCols } from "../../models/vessel-details.const";
import { getInputSpeedConsumption, togglePerfTableCol } from "../../services/vessel-details.service";
import { PerfManageColsMenu } from "../PerfManageColsMenu";
import { PerfTable } from "./PerfTable";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// TODO Interface for speed info
export const InputTable = () => {
  const [isLoading, setLoading] = useState(false);
  const { imoNumber, vesselCode, vesselName } = useParams();
  const [speedInfo, setSpeedInfo] = useState<any[]>([]);

  speedInfo.sort((a, b) => a?.INPUT_CONTRACT_VESSEL_SPEED - b?.INPUT_CONTRACT_VESSEL_SPEED);
  const speedDataBallast = speedInfo?.filter((user) => user.VESSEL_TYPE === "B");
  const speedDataLaden = speedInfo?.filter((user) => user.VESSEL_TYPE === "L");

  useEffect(() => {
    const speedFetchData = async () => {
      try {
        setLoading(true);
        const speed = await getInputSpeedConsumption(imoNumber, vesselCode, vesselName);
        setSpeedInfo(speed);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    speedFetchData();
  }, [imoNumber, vesselCode, vesselName, setSpeedInfo]);

  const [visCols, setVisCols] = useState<string[]>(inputTableCols);
  let ecoCount = inputColumns.length - visCols.length;

  const BallastMenuButton = PerfManageColsMenu(
    ecoCount,
    inputColumns,
    visCols,
    togglePerfTableCol(setVisCols),
    "INPUT_CONTRACT_VESSEL_SPEED",
  );

  return (
    <LoadingWrapper isLoading={isLoading} loadingIndicatorClassName="text-green" loadingIndicatorSize="lg">
      {PerfTable(
        inputColumns,
        "INPUT_CONTRACT_VESSEL_SPEED",
        visCols,
        speedInfo,
        speedDataBallast,
        speedDataLaden,
        BallastMenuButton,
      )}
    </LoadingWrapper>
  );
};
